/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.ASHA_INDEX = {

  '@50': 
  [
     500,
     501,
     '501s',
     '501.1',
     '501.2',
     502,
     503,
     '503s',
  ],
  '@AS': 
  [
     'Asha230SingleSIM',
     'Asha230DualSIM',
     'Asha500SingleSIM',
     'Asha500DualSIM',
  ],
};

/* This file is automatically generated, do not edit manually! */
